/**
 * SHA-256 sobre la serializacion canonica (spec/03-data-model.md §5).
 * entry_hash = H(canonicalizeEntry(content))
 * device_chain_hash(n) = H(device_chain_hash(n-1) || entry_hash(n))
 * device_chain_hash(0) = H(bookId || deviceId)  — raiz determinista, sin secreto.
 */

function getSubtle(): SubtleCrypto {
  const g = globalThis as { crypto?: Crypto };
  if (!g.crypto?.subtle) {
    throw new Error("SubtleCrypto no disponible en este entorno (globalThis.crypto.subtle)");
  }
  return g.crypto.subtle;
}

function toHex(buffer: ArrayBuffer): string {
  return Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export async function sha256Hex(input: string): Promise<string> {
  const bytes = new TextEncoder().encode(input);
  const digest = await getSubtle().digest("SHA-256", bytes);
  return toHex(digest);
}

export async function computeEntryHash(canonicalContent: string): Promise<string> {
  return sha256Hex(canonicalContent);
}

export async function computeChainRoot(bookId: string, deviceId: string): Promise<string> {
  return sha256Hex(`root|${bookId}|${deviceId}`);
}

export async function computeNextChainHash(previousChainHash: string, entryHash: string): Promise<string> {
  return sha256Hex(`${previousChainHash}|${entryHash}`);
}
